interface Props extends React.SVGProps<SVGSVGElement> {
  readonly size?: number;
}

export default function ArrowUpIcon(props: Props) {
  const { size = 14, ...rest } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 14"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g stroke="currentColor" strokeWidth="1.6" fill="none" fillRule="evenodd">
        <path d="M6 13.02V2.72" />
        <path
          strokeLinecap="square"
          strokeLinejoin="round"
          d="M6 2 2 5.63M6 2l4 3.63"
        />
      </g>
    </svg>
  );
}
